import Vue from 'vue'
import App from './App.vue'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/css/iconfont.css'
import '@/js/flexible'

Vue.config.productionTip = false
Vue.use(Vant)
new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
